import React, {createContext, FC} from 'react'

type TContext = {
  ImageComponent?: React.ComponentType<any>
  LinkComponent?: FC
  reachGoal?: (goal: string) => void
}

export const Context = createContext<TContext>({})
